/* eslint-disable */
import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
  Paper,
  Tooltip,
} from "@mui/material";
import { Cancel, KeyboardReturn } from "@mui/icons-material";
import CallReceivedIcon from '@mui/icons-material/CallReceived';
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { getEnvioAnteojoArreglo, receiveEnvioAnteojoArreglo } from "../../services/RecepcionAnteojoArregloService.js";
import VerAnteojoArregloDialog from "../ver-anteojo-arreglo/VerAnteojoArregloDialog.jsx";
import Message from "../../utils/Message.jsx";
import WaitingDialog from "../../utils/WaitingDialog";
import { format } from "date-fns";

const initialEnvioAnteojoArregloData = {
  codigoEnvioAnteojoArreglo: "",
  sucursalDestino: "",
  fechaRegistracion: format(new Date(), "dd/MM/yyyy"),
  observaciones: "",
};

const nameItemsText = "Envio de Anteojos / Arreglos";
//
// ###########################################################################
//
const EnvioAnteojoArreglo = () => {
  const navigate = useNavigate();
  const { action, idEnvioAnteojoArreglo } = useParams();
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [title, setTitle] = useState("");
  const [envioAnteojoArregloData, setEnvioAnteojoArregloData] = useState(
    initialEnvioAnteojoArregloData
  );
  const [envioAnteojoArregloRows, setEnvioAnteojoArregloRows] = useState([]);
  const [envioAnteojoArregloEstadoRows, setEnvioAnteojoArregloEstadoRows] = useState([]);
  const [openVerAnteojoArregloDialog, setOpenVerAnteojoArregloDialog] = useState(false);
  const [anteojoArreglo, setAnteojoArreglo] = useState("");
  const [idGestionAtencion, setIdGestionAtencion] = useState("");
  const [idGcAnteojoArreglo, setIdGcAnteojoArreglo] = useState("");
  const [codigoAnteojoArreglo, setCodigoAnteojoArreglo] = useState("");

  const tableColumns = [
    {
      field: "codigo_anteojo_arreglo",
      headerName: "Código Ant/Arr",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_anteojo_arreglo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "anteojo_arreglo",
      headerName: "Tipo",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.anteojo_arreglo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo_gc",
      headerName: "Código GC",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_gc;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cliente",
      headerName: "Cliente",
      headerAlign: "center",
      flex: 1,
      minWidth: 300,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombre_cliente + " " + params.row.apellido_cliente;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 150,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <Tooltip title="ver">
          <IconButton
            size="small"
            aria-label="update"
            onClick={() => handleAnteojoArreglo(params.row)}
          >
            <RemoveRedEyeOutlinedIcon />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const tableColumnsEstado = [
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = "";
        if (params.row.estado === "pendiente-recibir") {
          _val = "POR RECIBIR";
        } else if (params.row.estado === "recibido") {
          _val = "RECIBIDO";
        } else if (params.row.estado === "anulado") {
          _val = "ANULADO";
        }
        return _val;
      },
    },
    {
      field: "ultimo_estado",
      headerName: "Estado actual",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ultimo_estado ? "SÍ" : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Fecha Estado",
      flex: 1,
      headerAlign: "center",
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "username",
      headerName: "Vendedor/Operador",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.username;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    if (action === "view") {
      setTitle("Ver " + nameItemsText + " " + envioAnteojoArregloData.codigoEnvioAnteojoArreglo);
    } else if (action === "receive") {
      setTitle("Recibir " + nameItemsText + " " + envioAnteojoArregloData.codigoEnvioAnteojoArreglo);
    }

    const loadEnvioAnteojoArreglo = async () => {
      setIsDoingSomething(true);
      const response = await getEnvioAnteojoArreglo(idEnvioAnteojoArreglo);
      setIsDoingSomething(false);

      if (response.ok) {
        let _envioAnteojoArregloData = response.data.data;
        let _envioAnteojoArregloList = _envioAnteojoArregloData.envio_anteojo_arreglo_list;
        let _envioAnteojoArregloEstados =
          _envioAnteojoArregloData.envio_anteojo_arreglo_estado_list;

        setEnvioAnteojoArregloData({
          ...envioAnteojoArregloData,
          codigoEnvioAnteojoArreglo: _envioAnteojoArregloData.codigo,
          sucursalDestino: _envioAnteojoArregloData.descripcion_area_destino,
          fechaRegistracion: _envioAnteojoArregloData.fecha_creacion,
          observaciones: _envioAnteojoArregloData.observaciones,
        });
        setEnvioAnteojoArregloRows(_envioAnteojoArregloList);
        setEnvioAnteojoArregloEstadoRows(_envioAnteojoArregloEstados);
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };
    loadEnvioAnteojoArreglo();
  }, []);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setEnvioAnteojoArregloData({
      ...envioAnteojoArregloData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleSave = () => {
    let _envioAnteojoArregloObject = {
      id: idEnvioAnteojoArreglo,
    };

    save(_envioAnteojoArregloObject);
  };
  //
  // ################################################################################
  //
  const save = async (parEnvioAnteojoArreglo) => {
    setIsDoingSomething(true);
    const response = await receiveEnvioAnteojoArreglo(parEnvioAnteojoArreglo);
    setIsDoingSomething(false);

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (response.ok) {
      setTimeout(() => {
        window.close();
      }, 1000);
    }
  };
  //
  // ##########################################################################
  //
  const handleAnteojoArreglo = (parRow) => {
    setAnteojoArreglo(parRow.anteojo_arreglo);
    setCodigoAnteojoArreglo(parRow.codigo_anteojo_arreglo);
    setIdGcAnteojoArreglo(parRow.id_gc_anteojo_arreglo);
    setIdGestionAtencion(parRow.id_gc);
    setOpenVerAnteojoArregloDialog(true);
  };
  //
  // ################################################################################
  //
  const handleCloseVerAnteojoArregloDialog = () => {
    setOpenVerAnteojoArregloDialog(false);
  };
  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    window.close();
  };
  //
  // ################################################################################
  //
  return (
    <>
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={1} >
          <Box sx={{ mb: 1, p: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography variant="h5" display="block" gutterBottom>
                  {title}
                </Typography>
              </Grid>
            </Grid>

            <Grid container sx={{ mt: 1 }} spacing={1}>
              <Grid item xs={12} sm={8} md={4} lg={4}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="sucursalDestino"
                  label="Sucursal de Destino"
                  variant="outlined"
                  size="small"
                  name="sucursalDestino"
                  value={envioAnteojoArregloData.sucursalDestino}
                  onChange={handleChange}
                  InputProps={{ readOnly: true, autoComplete: "off" }}
                />
              </Grid>

              <Grid item xs={12} sm={8} md={2} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    maxLength: 3,
                  }}
                  id="fechaRegistracion"
                  label="Fecha de Registración"
                  variant="outlined"
                  size="small"
                  name="fechaRegistracion"
                  value={envioAnteojoArregloData.fechaRegistracion}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}></Grid>
            </Grid>

            {envioAnteojoArregloData.observaciones && (
              <Grid container sx={{ mt: 1 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    sx={{
                      "& .MuiInputBase-root": {
                        minHeight: "80px",
                        minWidth: "400px",
                      },
                    }}
                    id="observaciones"
                    label="Observaciones"
                    variant="outlined"
                    name="observaciones"
                    value={envioAnteojoArregloData.observaciones}
                    onChange={handleChange}
                    InputProps={{
                      readOnly: action !== "new",
                      autoComplete: "off",
                    }}
                    multiline
                    rows={3}
                    fullWidth
                  />
                </Grid>
                <Grid item xs={12} sm={12} md={6} lg={6}></Grid>
              </Grid>
            )}

            <Grid container sx={{ mt: 1 }} spacing={1}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {(envioAnteojoArregloData.anulado || action === "delete") && (
                  <TextField
                    autoFocus
                    sx={{ width: "100%" }}
                    inputProps={{
                      autoComplete: "off",
                    }}
                    id="motivoAnulacion"
                    label="Motivo de Anulación"
                    variant="outlined"
                    size="small"
                    name="motivoAnulacion"
                    value={envioAnteojoArregloData.motivoAnulacion}
                    onChange={handleChange}
                    InputProps={{
                      readOnly: envioAnteojoArregloData.anulado || action === "view",
                      autoComplete: "off",
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ border: "1px solid LightGrey", mb: 2, p: 1, borderRadius: "5px" }}>
            <Typography variant="subtitle1" sx={{ mt: 1, ml: 1 }}>
              Anteojos/Arreglos recibidos
            </Typography>
            <DataGrid
              rows={envioAnteojoArregloRows}
              columns={tableColumns}
              {...tableOptions}
            />
          </Box>

          {envioAnteojoArregloEstadoRows.length > 0 && (
            <Box sx={{ border: "1px solid LightGrey", mb: 2, p: 1, borderRadius: "5px" }}>
              <Typography variant="subtitle1" sx={{ mt: 1, ml: 1 }}>
                Estados del Envío de Anteojos/Arreglos
              </Typography>
              <DataGrid
                rows={envioAnteojoArregloEstadoRows}
                columns={tableColumnsEstado}
                {...tableOptions}
              />
            </Box>
          )}

          <Box sx={{ mx: 1, px: 1, pb: 1 }}>
            <Grid container spacing={1} justifyContent="flex-end">
              {action === "receive" && (
                <Grid item xs={12} md={2} lg={1}>
                  <Button
                    sx={{ mr: 1, width: "100%" }}
                    variant="contained"
                    size="small"
                    startIcon={<CallReceivedIcon />}
                    onClick={handleSave}
                  >
                    Recibir
                  </Button>
                </Grid>
              )}

              <Grid item xs={12} md={2} lg={1}>
                <Button
                  sx={{ mr: 1, width: "100%" }}
                  variant="outlined"
                  size="small"
                  onClick={handleCancelar}
                  startIcon={<Cancel />}
                >
                  {action === "view" ? "Cerrar" : "Cancelar"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Paper>

      {/* >>>> dialog para ver anteojo / arreglo */}

      {openVerAnteojoArregloDialog && (
        <VerAnteojoArregloDialog
          idGestionAtencion={idGestionAtencion}
          anteojoArreglo={anteojoArreglo}
          codigoAnteojoArreglo={codigoAnteojoArreglo}
          idGcAnteojoArreglo={idGcAnteojoArreglo}
          onClose={handleCloseVerAnteojoArregloDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </>
  );
};
export default EnvioAnteojoArreglo;
